import {
	DELETE_REGION,
	DELETE_REGION_SUCCESS,
	DELETE_REGION_FAIL,
	DELETE_REGION_RESET,
} from '../actions/deleteRegionAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const deleteRegionReducer = (state = initialState, action) => {
	switch (action.type) {
		case DELETE_REGION:
			return {
				...state,
				apiState: 'loading',
			};
		case DELETE_REGION_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case DELETE_REGION_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case DELETE_REGION_RESET:
			return initialState;
		default:
			return state;
	}
};

export default deleteRegionReducer;
